import types from "../types";

export function registerGroup(values) {
  return async (dispatch) => {
    return dispatch({
      type: types.REGISTER,
      payload: {
        request: {
          url: "groups/register",
          method: "POST",
          data: values,
        },
      },
    });
  };
}

export function getGroupsOptions() {
  return async (dispatch) => {
    return dispatch({
      type: types.GET_GROUPS_OPTIONS,
      payload: {
        request: {
          url: "groups",
          method: "GET",
        },
      },
    });
  };
}
